var $class="se2--content-introwith-popup-articles",$name="ContentIntrowithPopupArticles",$path="app/components/ContentIntrowithPopupArticles/index.js",$this={$class,$name,$path,};import shell from 'app/modules/shell';

import 'app/partials/image';

import initializeSlider from 'app/components/utilities/initializeSlider';
import isMobileBreakpoint from 'app/utilities/isMobileBreakpoint';

import { css, keyNames } from 'configs';

import first from 'lodash/first';
import last from 'lodash/last';

import goalSliderClassName from './partials/goalSlider';

import {
  activeSlideClassName,
  closeButtonClassName,
  controlsClassName,
  mainInfoClassName,
  nextButtonClassName,
  openGoalClassName,
  prevButtonClassName,
  sliderClassName,
  slideClassName,
} from './config';

export default shell.registerComponent($this, ({ addEventListener, mount }) => {
  const openGoalButtonSizeDesktop = 216;

  const setGridRowEnd = (elem) => {
    elem.style.gridRowEnd = isMobileBreakpoint()
      ? 'unset'
      : Math.ceil(elem.scrollHeight / openGoalButtonSizeDesktop) + 1;
  };

  const closeGoalSlider = (slider, element) => {
    slider.classList.add(css.classNames.hide);
    const activeSlide = slider.querySelector(`.${activeSlideClassName}`);
    element.querySelector(`[data-index='${activeSlide.dataset.index}']`).focus();
    document.body.style.overflow = 'auto';
  };

  mount((element) => {
    let currentSlider = null;

    const slides = element.querySelectorAll(`.${slideClassName}`);

    const mainInfo = element.querySelector(`.${mainInfoClassName}`);
    if (mainInfo) setGridRowEnd(mainInfo);

    if (slides.length) {
      const closeButton = element.querySelector(`.${closeButtonClassName}`);
      const goalSlider = element.querySelector(`.${goalSliderClassName}`);

      goalSlider?.classList.remove(css.classNames.hide);
      currentSlider = initializeSlider(element, addEventListener, {
        containerSelector: `.${sliderClassName}`,
        isArticleSlides: true,
        nextButtonSelector: `.${nextButtonClassName}`,
        prevButtonSelector: `.${prevButtonClassName}`,
        preventKeyNavigation: true,
        slideSelector: `.${slideClassName}`,
        swiperContainerSelector: `.${sliderClassName}`,
      });

      goalSlider?.classList.add(css.classNames.hide);

      addEventListener(window, 'resize', () => {
        currentSlider?.onResize();

        if (mainInfo) setGridRowEnd(mainInfo);
      });

      addEventListener(document, 'keydown', (event) => {
        if (!goalSlider.classList.contains(css.classNames.hide)) {
          const { escape, tab } = keyNames;
          const { code, shiftKey, target } = event;

          const focusableElements = goalSlider.querySelectorAll(
            `.${controlsClassName} button, .${closeButtonClassName}, .${activeSlideClassName} a`,
          );
          const firstFocusableElement = first(focusableElements);
          const lastFocusableElement = last(focusableElements);

          switch (code) {
            case escape:
              closeGoalSlider(goalSlider, element);
              break;
            case tab:
              if (shiftKey) {
                if (target === firstFocusableElement) {
                  lastFocusableElement?.focus();
                  event.preventDefault();
                }
              } else if (target === lastFocusableElement) {
                firstFocusableElement?.focus();
                event.preventDefault();
              }
              break;
            default:
              break;
          }
        }
      });

      addEventListener(element, 'click', ({ target }) => {
        const goalButton = target.closest(`.${openGoalClassName}`);

        if (goalButton) {
          goalSlider.classList.remove(css.classNames.hide);
          currentSlider?.onResize();
          currentSlider?.setActiveElement(+goalButton.dataset.index);

          document.activeElement.blur();
          document.body.style.overflow = 'hidden';
          goalSlider.querySelector(`.${sliderClassName} .${closeButtonClassName}`).focus();
        } else if (target === goalSlider || target === closeButton) {
          closeGoalSlider(goalSlider, element);
        }
      });
    }
  });
});
